const waitingOn = document.querySelector(".waiting-page")
const navWait = document.querySelector("nav")
const footerWait = document.querySelector("footer")
const textJours = document.querySelector(".wait-jours")
const textHours = document.querySelector(".wait-hours")
const textMins = document.querySelector(".wait-mins")
const textSec = document.querySelector(".wait-sec")

if(waitingOn) {
  navWait.classList.add("waiting-hide");
  footerWait.classList.add("waiting-hide");


  function getChrono(){

    const now = new Date().getTime();
    const countdownDate = new Date('March 03, 2022').getTime();
  
    const distanceBase = countdownDate - now;
  
    const days = Math.floor(distanceBase / (1000 *60 *60 * 24));
    const hours = Math.floor((distanceBase % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mins = Math.floor((distanceBase % (1000 * 60 * 60 )) / (1000 * 60 ));
    const secs = Math.floor((distanceBase % (1000 * 60 )) / 1000 );
  
    textJours.innerText  = days
    textHours.innerText  = hours
    textMins.innerText  = mins
    textSec.innerText  = secs

  }

  const countDownInterval = setInterval(() => {

    getChrono();

  }, 1000);



}


